<template>
  <div class="ll-stepper-header">
    <LlStepperStep
      v-for="(step,stepIndex) in stepList"
      :key="stepIndex"
      :step-number="step.id"
      :title="step.title"
      :divider-width="lineWidth"
      :have-line="stepIndex > 0"
      :is-active="stepIndex + 1 <= ingStep"
      @step-click=" $_stepClick(step.id)"
    />
  </div>
</template>
<script>
export default {
  name: "LlStepperHeader",
  props: {
    stepList: {
      type: Array,
      default() {
        return [];
      },
    },
    completeList: {
      type: Array,
      default() {
        return [];
      },
    },
    lineWidth: {
      type: Number,
      default: 0,
    },
    ingStep: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    $_stepClick($event) {
      this.$emit("step-click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-stepper-header";
</style>